// components/StyledCTA.tsx
'use client'

import Link from 'next/link'
import { buttonVariants } from '@/components/ui/button-variants';
import { cn } from '@/lib/utils'
import { ArrowRight } from 'lucide-react'

type Props = {
  href: string
  variant?: 'default' | 'outline'
  size?: 'lg'
  className?: string
  children: React.ReactNode
}

export function StyledCTA({
  href,
  variant = 'default',
  size = 'lg',
  className,
  children,
}: Props) {
  return (
    <Link
      href={href}
      className={cn(buttonVariants({ variant, size }), className)}
    >
      {children}
      <ArrowRight className="ml-2 h-5 w-5" />
    </Link>
  )
}

